import { FormQuestionFieldsComponent } from './form-question-fields.component';

export default angular
  .module('sfMobile.components.question-fields', [
    'sfMobile.services.forms',
  ])
  .component('sfFormQuestionFields', FormQuestionFieldsComponent).name;
